import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { SiteProvider } from "@/context/SiteContext";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import ThemeLayout from "@/components/ThemeLayout";

import StampPage from "@/pages/StampPage";
import SportsPage from "@/pages/SportsPage";
import StorePage from "@/pages/StorePage";
import ProductPage from "@/pages/ProductPage";
import CheckoutPage from "@/pages/CheckoutPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function App() {
  return (
    <SiteProvider>
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <ThemeLayout>
              <Routes>
                <Route path="/" element={<StampPage />} />
                <Route path="/k8-sports" element={<SportsPage />} />
                <Route path="/pagode-das-cinco-pontas" element={<StorePage />} />
                <Route path="/pagode-das-cinco-pontas/produto/:id" element={<ProductPage />} />
                <Route path="/pagode-das-cinco-pontas/checkout" element={<CheckoutPage />} />
                <Route path="/admin" element={<AdminLogin />} />
                <Route path="/admin/painel" element={<AdminDashboard />} />
              </Routes>
            </ThemeLayout>
            <Toaster position="top-center" richColors />
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </SiteProvider>
  );
}

export default App;
